import logo from '../assets/logo.svg';
import { useT } from '../i18n';
import { Icon } from '../components/Icon/Icon';
import { STAGES, type Stage } from '../app/registry';

export interface HeaderProps {
  /** Back handler; undefined hides the arrow (its cell stays, so the logo stays centred). */
  onBack?: () => void;
  /** Rail stage lit as "now"; null hides the rail. */
  stage: Stage | null;
}

/** Back arrow + centred wordmark + the three-stage rail (design rule 9). */
export function Header({ onBack, stage }: HeaderProps) {
  const t = useT();
  return (
    <header className="chrome">
      <div className="chrome__bar">
        <button
          type="button"
          className={`iconbtn${onBack ? '' : ' iconbtn--gone'}`}
          aria-label={t('common.back')}
          aria-hidden={onBack ? undefined : true}
          tabIndex={onBack ? undefined : -1}
          onClick={onBack}
          data-testid="chrome-back"
        >
          <Icon name="back" />
        </button>
        <img className="chrome__mark" src={logo} alt={t('common.logoAlt')} />
        <span />
      </div>
      {stage && <Rail stage={stage} />}
    </header>
  );
}

export function Rail({ stage }: { stage: Stage }) {
  const t = useT();
  const now = STAGES.indexOf(stage);
  return (
    <ol className="rail" aria-label={t('common.railLabel')} data-testid="chrome-rail">
      {STAGES.map((s, i) => (
        <li
          key={s}
          className={`rail__seg${i === now ? ' is-now' : ''}${i < now ? ' is-done' : ''}`}
          aria-current={i === now ? 'step' : undefined}
        >
          {t(`common.rail.${s}`)}
        </li>
      ))}
    </ol>
  );
}
